import { render, staticRenderFns } from "./EstablishmentRolesComponent.vue?vue&type=template&id=08dd9830&"
import script from "./EstablishmentRolesComponent.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRolesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports